import { useState } from "react";
import "@/App.css";
import { AppProvider, useApp } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import NameSwitcher from "@/components/NameSwitcher";
import Layout from "@/components/Layout";
import OwnerDashboard from "@/pages/OwnerDashboard";
import DailyEntry from "@/pages/DailyEntry";
import Overview from "@/pages/Overview";
import Analytics from "@/pages/Analytics";
import Leaderboard from "@/pages/Leaderboard";
import Goals from "@/pages/Goals";
import ManagerWorkspace from "@/pages/ManagerWorkspace";
import Settings from "@/pages/Settings";

function Shell() {
  const { currentUser, loading } = useApp();
  const [tab, setTab] = useState("dashboard");

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0b1120]">
        <div className="animate-pulse text-[#C9A24B] font-heading font-light text-xl">Loading tracker…</div>
      </div>
    );
  }

  if (!currentUser) return <NameSwitcher />;

  return (
    <Layout tab={tab} setTab={setTab}>
      {tab === "dashboard" && <OwnerDashboard />}
      {tab === "daily" && <DailyEntry />}
      {tab === "overview" && <Overview />}
      {tab === "analytics" && <Analytics />}
      {tab === "leaderboard" && <Leaderboard />}
      {tab === "goals" && <Goals />}
      {tab === "manager" && <ManagerWorkspace />}
      {tab === "settings" && <Settings />}
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <Shell />
        <Toaster position="top-center" richColors />
      </AppProvider>
    </div>
  );
}

export default App;
